import { Injectable } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import { LoggingService } from '../shared/logging.service';
import { WorkflowService } from './workflow-service';
import { ConfigService } from './config.service';

@Injectable()
export class TaskGuardService  {

  constructor(private userService: UserService,
              private workflowService: WorkflowService,
              private loggingService: LoggingService,
              private configService: ConfigService,
              private router: Router) {
  }

  /**
   * Temporary fix so that a page refresh does not break the whole system
   * @returns {Promise<T>}
   */
  public canActivate(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // Check if session is active
      setTimeout(() => {
        const user = this.userService.getUser();
        if (user) {
          // Making sure we are also loading the required data together with the user
          const dataFetch: Promise<any>[] = [];

          dataFetch.push(this.workflowService.retrieveWorkflowActions());
          dataFetch.push(this.configService.retrieveServices());
          dataFetch.push(this.configService.retrieveFileCategoryTypes());
          dataFetch.push(this.configService.retrieveRejectReasons());
          dataFetch.push(this.configService.retrieveServiceComponents());

          // When all the data finishes loading async
          Promise.all(dataFetch)
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              console.error('Failed to load session instance for tasks.');
              resolve(false);
              this.router.navigate(['error-404']);
            });

          return;
        }

        // If session is not active, redirect to login
        // this._router.navigate(['/auth/login']);
        this.loggingService.warn('Could not load task session, sending rejection');
        reject(false);
      });
    });
  }
}
